import { gql } from '@apollo/client';

export const obtenerWordpressMenu = gql`
  query obtenerWordpressMenu($id: Int){
    menuWP: wordpressMenu(id: $id) {      
      items {
        title
        description
        img
        url
        children {
          title
          url
          img
          description
          children {
            title
            url
          }
        }
      }
    }
  }
`
